
export function addSubscribeNewsletterToForm(formID, responseArea) {
    const form = document.querySelector('#' + formID);

    if (form) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            form.parentNode.classList.add('disabled');
            subscribeNewsletter(form).then((res) => {
                return res.json();
            }).then(data => {
                form.parentNode.classList.remove('disabled');
                handleSubmissionResponse(data, responseArea, form);
            });
        });
    }
}

const subscribeNewsletter = (formElement) => {
    let formData = new FormData(formElement);

    return fetch(ajax.baseUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
      })
      .then((res) => {
          return res;
      })
  }

  const handleSubmissionResponse = (response, responseArea, form) => {
    response.error ? responseArea.classList.add('error') : responseArea.classList.remove('error');
    responseArea.innerHTML = response.message;
    form.querySelector('.mcl-input').style.marginBottom = '0'
    console.log(form.querySelector('.mcl-input').style);
  }



// WEBPACK FOOTER //
// ./src/layouts/general/subscribe-newsletter.js